let portalUrlVar;
let intercomAppIdVar;
let helpUrlVar;
let oauthProvider;
if (BUILD_TARGET === 'beta' || BUILD_TARGET === 'live') {
  portalUrlVar = 'https://portal.mintel.com';
  helpUrlVar = 'https://help.mintel.com';
  oauthProvider = 'https://oauth.mintel.com';
  intercomAppIdVar = 'ge9d772l';
} else if (BUILD_TARGET === 'local' || BUILD_TARGET === 'test') {
  intercomAppIdVar = 'p64o2k47';
  if (AUTH === 'qa') {
    portalUrlVar = 'https://qa-portal.mintel.com';
    helpUrlVar = 'https://test-help.mintel.com';
    oauthProvider = 'https://qa-oauth.mintel.com';
  } else if (AUTH === 'local') {
    portalUrlVar = 'https://qa-portal.mintel.com';
    helpUrlVar = 'https://test-help.mintel.com';
    oauthProvider = 'http://localhost:8081';
  } else {
    portalUrlVar = 'https://portal.mintel.com';
    helpUrlVar = 'https://help.mintel.com';
    oauthProvider = 'https://oauth.mintel.com';
  }
} else {
  throw new Error(`Unexpected build target '${BUILD_TARGET}'`);
}

const OAUTH_CLIENT_IDS = {
  'https://oauth.mintel.com': 'GugZbGMQj0PKG7J0WXe6YPdrcItPcgQ1Guw0sqIv',
  'https://qa-oauth.mintel.com': 'pKgCmwwMzlRmCzrVoibS52QtkDRbmlCYTWbZnG6k',
  // Mock OAuth provider
  'http://localhost:8081': '',
};

// Full list of options can be found here: https://github.com/IdentityModel/oidc-client-js/wiki#configuration
export const authConfig = {
  authority_configuration: {
    authorization_endpoint: `${oauthProvider}/authorize/`,
    token_endpoint: `${oauthProvider}/token/`,
    userinfo_endpoint: `${oauthProvider}/userinfo/`,
    revocation_endpoint: '',
    // Pull issuer from window as set in index.html template
    // This is to avoid EZProxy URL re-writing
    issuer: window.authConfigIssuer,
  },
  authority: oauthProvider,
  client_id: OAUTH_CLIENT_IDS[oauthProvider],
  redirect_uri: window.authRedirectURI,
  scope: 'openid profile email intercom',
  storage: window.localStorage,
};

export const portalUrl = portalUrlVar;
export const portalJwtUrl = `${portalUrlVar}/oauth-exchange/token/`;
export const IntercomAppId = intercomAppIdVar;
export const IntercomHelpUrl = helpUrlVar;
